<template>
  <v-container>
    <v-layout row wrap v-if="error">
      <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
        <v-alert :value="true">{{ error }}</v-alert>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="track" :class="['track-details']" align-space-between fill-height>
      <v-flex lg6 md6 sm12 xs12 :class="['pa-2']">
        <v-card :class="['full-height']">
          <v-card-text>
            <h3 v-html="track.title" :class="['font-weight-light', 'title', 'pb-3']" />
            <div :class="['pb-3', 'font-weight-light', 'subheading', 'mb-1']">
              {{ $lang.fromTheAlbum }}&nbsp;"<router-link
              :title="$lang.viewRelease(track.album.title)"
              :class="['white--text', 'font-weight-medium']"
              :to="`/music/${track.album.slug}`"
              v-html="track.album.title" />"
            </div>
            <div>
              <iframe v-if="!$root.albumIdForTheTrackPage || $config.bandCampPlayer.use" title="bandcamp-embedded-player" seamless :src="playerSrc" />
              <on-page-vc-audio-player
                v-if="$root.albumIdForTheTrackPage && !$config.bandCampPlayer.use"
                :track="track.embedParams[1].track"
                :art="track.art"
                :controls="controls"
                :album="$root.albumIdForTheTrackPage"
              />
            </div>
            <p v-html="track.about" :class="['mt-3', 'text-xs-center', 'caption', 'mb-0']" />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex lg6 md6 sm12 xs12 :class="['pa-2']">
        <v-card :class="['full-height']">
          <v-card-text>
            <v-img @click="showImageInLightbox(track.art)" ripple :lazy-src="$config.replacementImage" :src="track.art" :class="['clickable', 'elevation-12']" />
            <v-btn v-if="$root.albumIdForTheTrackPage && !$config.bandCampPlayer.use" :class="['mt-3']" block :color="$config.colors.primary" aria-label="play-track" :title="$lang.playTrackInNewWindow" @click="playTrack($root.albumIdForTheTrackPage, track.embedParams[1].track)">
              <v-icon>mdi-play-circle-outline</v-icon>&nbsp;{{ $lang.playTrackInNewWindow }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <featured-video :slug="slug" />
    </v-layout>
    <news-ticker />
  </v-container>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'PageMusicAlbumTrack',
  mixins: [
    methods
  ],
  data () {
    return {
      error: null,
      track: null,
      slug: this.$route.params.track,
      controls: [
        'playpause',
        'volume',
        'previous',
        'next',
        'scrobber'
      ]
    }
  },
  computed: {
    playerSrc () {
      return `https://bandcamp.com/EmbeddedPlayer/size=small/bgcol=333333/linkcol=9a64ff/artwork=none/track=${this.track.embedParams[1].track}/transparent=true/`
    }
  },
  mounted () {
    this.getTrack()
  },
  methods: {
    playTrack (album, track) {
      this.openVcAudioPlayer(album, track)
    },
    setTrack (data) {
      this.track = data
    },
    getTrack () {
      const url = this.getBCRoute('track')
      const slug = this.$route.path
      const cachedData = this.retrieveCachedData('music', slug)
      if (cachedData) {
        return this.setTrack(cachedData)
      }
      this.$http({
        url,
        method: 'POST',
        data: {
          track: this.slug,
          artist: this.$config.bcArtistSlug
        }
      }).then(response => {
        const code = response.data.code
        if (code === 0) {
          const data = response.data.data
          this.setTrack(data)
          this.cacheData(slug, 'music', data)
        } else {
          this.error = this.$lang.errors[code]
        }
      }).catch(error => {
        console.error(error)
      })
    }
  }
}
</script>
<style>
.track-details iframe
{
  border: 0;
  width: 100%;
  height: 42px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/music-album-track.vue